import type { ReactNode } from "react";

interface SectionHeadingProps {
  index: string;
  title: string;
  subtitle?: string;
  action?: ReactNode;
  invert?: boolean;
}

export default function SectionHeading({
  index,
  title,
  subtitle,
  action,
  invert = false,
}: SectionHeadingProps) {
  return (
    <div className="mb-8 flex flex-col gap-4 md:mb-10 md:flex-row md:items-end md:justify-between">
      <div className="max-w-2xl">
        <div className="mb-3 flex items-center gap-3">
          <span
            className={`font-heading text-sm font-bold tracking-[0.3em] ${
              invert ? "text-primary-300" : "text-primary-600"
            }`}
          >
            FILE {index}
          </span>
          <span className={`h-px w-10 ${invert ? "bg-background-700" : "bg-primary-300"}`} />
        </div>
        <h2
          className={`font-heading text-2xl font-bold leading-snug md:text-4xl ${
            invert ? "text-background-50" : "text-foreground-950"
          }`}
        >
          {title}
        </h2>
        {subtitle ? (
          <p className={`mt-3 text-sm leading-relaxed md:text-base ${invert ? "text-background-300" : "text-foreground-600"}`}>
            {subtitle}
          </p>
        ) : null}
      </div>
      {action ? <div className="shrink-0">{action}</div> : null}
    </div>
  );
}